// global
import { push } from 'react-router-redux';
// local
// actions
import { showSnackbar } from 'app/redux/actions/snackbar';
import { pending, rejected, fulfilled } from './async';
import dispatchError from './error';
import { showNotification } from './notification';
// api
import * as Monitor from 'app/api/monitor';

const ACTION_KEY = 'MONITOR';

export function reset() {
    return {
        type: `${ACTION_KEY}_RESET`,
    };
}

const updatePrescriptionAction = function(patientId, newPrescription) {
    return {
        type: `${ACTION_KEY}_UPDATE_PRESCRIPTION`,
        payload: { patientId, newPrescription },
    };
};

export function updatePrescription(patientId, newPrescription) {
    return dispatch => {
        Monitor.updatePrescription(patientId, { newPrescription })
            .then(() => {
                dispatch(updatePrescriptionAction(patientId, newPrescription));
                dispatch(showSnackbar({ title: 'Prescrição alterada com sucesso!', action: true }));
            })
            .catch(err => dispatchError(dispatch, err));
    };
}

const addRestitutionAction = function(patientId) {
    return {
        type: `${ACTION_KEY}_ADD_RESTITUTION`,
        payload: patientId,
    };
};

export function addRestitution(patientId) {
    return dispatch => {
        dispatch(updateAutoUpdate(false));
        Monitor.addRestitution(patientId)
            .then(() => dispatch(addRestitutionAction(patientId)))
            .catch(err =>
                dispatchError(dispatch, err, () => {
                    dispatch(showNotification([{ key: 'monitor__restitution' }]));
                }),
            );
    };
}

const removeRestitutionAction = function(patientId) {
    return {
        type: `${ACTION_KEY}_REMOVE_RESTITUTION`,
        payload: patientId,
    };
};

export function removeRestitution(patientId) {
    return dispatch => {
        dispatch(updateAutoUpdate(false));
        Monitor.removeRestitution(patientId)
            .then(() => dispatch(removeRestitutionAction(patientId)))
            .catch(err =>
                dispatchError(dispatch, err, () => {
                    dispatch(showNotification([{ key: 'monitor__restitution' }]));
                }),
            );
    };
}

export function updateAutoUpdate(autoUpdate) {
    return {
        type: `${ACTION_KEY}_UPDATE_AUTO_UPDATE`,
        payload: autoUpdate,
    };
}

export function updateView(view) {
    return {
        type: `${ACTION_KEY}_UPDATE_VIEW`,
        payload: view,
    };
}

export function updateMapParams(params) {
    return {
        type: `${ACTION_KEY}_UPDATE_MAP_PARAMS`,
        payload: params,
    };
}

export function resetMapParams() {
    return {
        type: `${ACTION_KEY}_RESET_MAP_PARAMS`,
    };
}

export function oxigenByPatient() {
    return dispatch => {
        dispatch(pending(ACTION_KEY));
        Monitor.oxigenByPatient()
            .then(payload => dispatch(fulfilled(ACTION_KEY, payload)))
            .catch(err => dispatch(rejected(ACTION_KEY, err)));
    };
}

export function search(term) {
    return {
        type: `${ACTION_KEY}_SEARCH`,
        payload: term,
    };
}

export function filter(values) {
    return {
        type: `${ACTION_KEY}_FILTER`,
        payload: values,
    };
}

export function openDetail(id) {
    return push(`/patients/${id}`);
}
